"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.mutations = exports.getters = exports.fnMakeDispatches = exports.fnMakeCommits = exports.fnMakeGetters = exports.state = void 0;
var nvuex_1 = require("../plugins/nvuex");
var dev_performance_1 = __importDefault(require("../core/store/dev.performance"));
var uploadStateEnum_1 = require("../core/fileUpload/uploadStateEnum");
var userActivity_1 = require("../core/enums/userActivity");
var MODULE = "fileUpload";
//-------------------------------------------------------------------------------------------------
// state
var _state = function () { return ({
    processState: uploadStateEnum_1.PROCESSING_STATES.INACTIVE,
    hide: false,
    files: new Array(),
    lastFile: null,
    currentFileIndex: -1,
    fileReport: null,
    incomingFiles: new Array(),
    incomingProjects: new Array(),
    incomingTargetProjects: new Array(),
    displayDragNDropPanel: false,
}); };
exports.state = _state;
function typeGetters(o) {
    return o;
}
var _getters = typeGetters({
    busy: function (s) {
        return (!s.hide &&
            (s.processState !== uploadStateEnum_1.PROCESSING_STATES.INACTIVE ||
                s.files.filter(function (file) { return file.state === uploadStateEnum_1.FILE_STATUS.UPLOAD_FAILED; })
                    .length > 0));
    },
    canCancel: function (s) {
        return (s.files.filter(function (file) { return file.state !== uploadStateEnum_1.FILE_STATUS.STATIC; }).length == 0);
    },
    filesBeingProcessed: function (s) {
        return s.files.filter(function (file) { return file.state !== uploadStateEnum_1.FILE_STATUS.FILE_PROCESSED; });
    },
    hasErrors: function (s) {
        return s.files.filter(function (file) { return file.state !== uploadStateEnum_1.FILE_STATUS.UPLOAD_FAILED; }).length > 0;
    },
    filesToUploadCount: function (s) {
        return s.files.filter(function (file) { return file.state == uploadStateEnum_1.FILE_STATUS.STATIC; }).length;
    },
    imageBeingResized: function (s) {
        return s.files.filter(function (file) { return file.state == uploadStateEnum_1.FILE_STATUS.FILE_UPLOADED; }).length;
    },
});
function fnMakeGetters(store) {
    return (0, nvuex_1.makeGetters)(store, MODULE, _getters);
}
exports.fnMakeGetters = fnMakeGetters;
function typeMutations(o) {
    return o;
}
var _mutations = typeMutations({
    updateProcessingState: function (_state, _a) {
        var processState = _a.processState, fileReport = _a.fileReport;
        _state.processState = processState;
        _state.fileReport = fileReport;
    },
    addFiles: function (_state, files) {
        var _a;
        (_a = _state.files).push.apply(_a, files);
        _state.hide = false;
    },
    updateFile: function (_state, file) {
        if (file.state === uploadStateEnum_1.FILE_STATUS.FILE_PROCESSED) {
            _state.lastFile = file;
        }
        var index = _state.files.findIndex(function (o) { return o.id == file.id; });
        if (index !== -1) {
            _state.files[index].state = file.state;
            _state.files[index].uploadProgress = file.uploadProgress;
            _state.files[index].uploadId = file.uploadId;
        }
        _state.currentFileIndex = index;
    },
    reset: function (_state) {
        _state.processState = uploadStateEnum_1.PROCESSING_STATES.INACTIVE;
        // _state.tags = [];
        _state.files = [];
        _state.hide = false;
        _state.incomingFiles = [];
        _state.incomingProjects = [];
        _state.incomingTargetProjects = [];
        _state.currentFileIndex = -1;
    },
    hide: function (s) {
        s.hide = true;
    },
    setIncomingFiles: function (s, v) {
        s.incomingFiles = v;
    },
    setIncomingProjects: function (s, v) {
        s.incomingProjects = v;
    },
    setIncomingTargetProjects: function (s, v) {
        s.incomingTargetProjects = v;
    },
    setDisplayDragNDropPanel: function (s, v) {
        s.displayDragNDropPanel = v;
    },
});
function fnMakeCommits(store) {
    return (0, nvuex_1.makeCommits)(store, MODULE, _mutations);
}
exports.fnMakeCommits = fnMakeCommits;
function typeActions(o) {
    return o;
}
var _actions = typeActions({
    addFiles: function (_a, files) {
        var commit = _a.commit;
        commit("addFiles", files);
    },
    updateFile: function (_a, file) {
        var commit = _a.commit;
        commit("updateFile", file);
        if (file &&
            file.uploadProgress == 100 &&
            file.state == uploadStateEnum_1.FILE_STATUS.FILE_PROCESSED) {
            this.$userActivity.publish(userActivity_1.UserActivityEnum.FileUploaded);
        }
    },
    setProcessingState: function (_a, processState) {
        var commit = _a.commit, state = _a.state;
        var fileReport = null;
        if (processState == 0) {
            fileReport = {
                filesUploaded: state.files.filter(function (fileModel) { return fileModel.state > uploadStateEnum_1.FILE_STATUS.STATIC; }).length,
                filesFailed: state.files.filter(function (fileModel) { return fileModel.state == uploadStateEnum_1.FILE_STATUS.UPLOAD_FAILED; }).length,
                filesCancelled: 0,
                filesUploadForbidden: state.files.filter(function (fileModel) { return fileModel.state == uploadStateEnum_1.FILE_STATUS.FORBIDDEN; }).length,
            };
        }
        var data = {
            processState: processState,
            fileReport: fileReport,
        };
        commit("updateProcessingState", data);
    },
    hide: function (_a) {
        var commit = _a.commit;
        commit("hide");
    },
    reset: function (_a) {
        var commit = _a.commit;
        commit("reset");
    },
});
function fnMakeDispatches(store) {
    return (0, nvuex_1.makeDispatches)(store, MODULE, _actions);
}
exports.fnMakeDispatches = fnMakeDispatches;
//-------------------------------------------------------------------------------------------------
// exports
exports.getters = dev_performance_1.default.nWrapGetterTree(MODULE, _getters);
exports.mutations = dev_performance_1.default.nWrapMutationTree(MODULE, _mutations);
exports.actions = dev_performance_1.default.nWrapActionTree(MODULE, _actions);
//-------------------------------------------------------------------------------------------------
//# sourceMappingURL=fileUpload.js.map